import { styled } from "styled-components";
import { AiOutlineFileExcel } from 'react-icons/ai';

export default function DownloadButton(props) {
    return(
        <CustomButton {...props}>
            <span>{props.children}</span>
            <AiOutlineFileExcel size="1.8rem" />
        </CustomButton>
    );
}

const CustomButton = styled.button`
    border: none;
    background-color: ${({theme}) => theme.colors.download};
    color: #fff;
    padding: 0.75rem 1rem;
    background-color: ${({bg}) => bg};
    border: none;
    font-size: 1.5rem;
    letter-spacing: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    border-radius: 0.2rem;
    cursor: pointer;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 5px 5px 5px #ccc;
    }
    &:active {
        transform: translateY(0);
        box-shadow: 3px 3px 3px #ccc;
    }
`;